
import React from 'react'
import icon from './svgs/targetColored.svg'
import { BaseIcon } from './_base'

export const TargetColoredIcon = ({ size, fontSize ,sx}) => {
    return (
        <BaseIcon icon={icon} {...{fontSize,size,...sx}} />
    )
}
